module.exports = __webpack_public_path__ + "img/goTop2.fd4cfb30.png";